import { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { toast } from "sonner";
import { Mail, Send, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LeadForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !email.trim()) {
      toast.error("Preencha nome e e-mail para continuar.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/leads`, { name: name.trim(), email: email.trim() });
      setDone(true);
      toast.success("Cadastro confirmado! Fique de olho no seu e-mail.");
    } catch {
      toast.error("Não foi possível enviar. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section data-testid="lead-capture-section" className="relative px-6 py-28 sm:py-36 lg:px-12">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 lg:grid-cols-2">
        <motion.div
          initial={{ opacity: 0, y: 32 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.8 }}
        >
          <p className="font-mono-label text-xs uppercase tracking-[0.3em] text-[#D4AF37]">Ainda em dúvida?</p>
          <h2 className="font-serif-display mt-6 text-3xl font-semibold leading-tight text-white sm:text-4xl lg:text-5xl">
            Receba novidades e
            <span className="italic text-[#D4AF37]"> conteúdos exclusivos.</span>
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-[#A1A1AA]">
            Deixe seu nome e e-mail para receber em primeira mão dicas práticas de Social Media
            e condições especiais do e-book. Sem spam, só o que importa.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 32 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.8, delay: 0.15 }}
        >
          {done ? (
            <div data-testid="lead-success-message" className="flex flex-col items-start gap-4 rounded-2xl border border-[rgba(212,175,55,0.35)] bg-[#121212] p-10">
              <CheckCircle2 className="h-10 w-10 text-[#D4AF37]" strokeWidth={1.5} />
              <h3 className="font-serif-display text-2xl font-semibold text-white">Cadastro confirmado!</h3>
              <p className="text-sm leading-relaxed text-[#A1A1AA]">
                Obrigado, {name.split(" ")[0]}. Você entrou na lista e vai receber as novidades em primeira mão.
              </p>
            </div>
          ) : (
            <form onSubmit={submit} className="rounded-2xl border border-[rgba(255,255,255,0.08)] bg-[#121212] p-8 sm:p-10">
              <label className="font-mono-label block text-[10px] uppercase tracking-[0.25em] text-[#71717A]">Seu nome</label>
              <input
                data-testid="lead-name-input"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Como podemos te chamar?"
                className="mt-3 w-full border-b border-[rgba(255,255,255,0.15)] bg-transparent pb-3 text-base text-white placeholder:text-[#3f3f46] focus:border-[#D4AF37] focus:outline-none transition-colors duration-300"
              />
              <label className="font-mono-label mt-8 block text-[10px] uppercase tracking-[0.25em] text-[#71717A]">Seu melhor e-mail</label>
              <div className="mt-3 flex items-center gap-3 border-b border-[rgba(255,255,255,0.15)] pb-3 transition-colors duration-300 focus-within:border-[#D4AF37]">
                <Mail className="h-4 w-4 shrink-0 text-[#71717A]" />
                <input
                  data-testid="lead-email-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="voce@email.com"
                  className="w-full bg-transparent text-base text-white placeholder:text-[#3f3f46] focus:outline-none"
                />
              </div>
              <button
                data-testid="lead-submit-button"
                type="submit"
                disabled={loading}
                className="group mt-10 inline-flex w-full items-center justify-center gap-3 rounded-full border border-[#D4AF37] px-8 py-4 text-sm font-bold uppercase tracking-[0.15em] text-[#D4AF37] transition-colors duration-300 hover:bg-[#D4AF37] hover:text-[#0A0A0A] disabled:opacity-50"
              >
                {loading ? "Enviando..." : "Entrar para a lista"}
                <Send className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-0.5" />
              </button>
              <p className="mt-5 text-center text-xs text-[#71717A]">Seus dados estão seguros. Nada de spam.</p>
            </form>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default LeadForm;
